import React from "react";
import { useDispatch} from "react-redux";
import { filterCreated } from "../../actions";
import "./FilterGameCreated.css"

export default function FilterCreats({setcurrentPage}){
    const dispatch = useDispatch();


        //filtramos, traemos a los creados.
        function handleFilterCreated(event){
            event.preventDefault();
            dispatch(filterCreated(event.target.value));
            setcurrentPage(1)
        }

    return(
        <div className="conteinerFilterCreated">
            <select className="selectFilterCreated" onChange={event => handleFilterCreated(event)}>
                <option value="all">Todos</option>
                <option value="created">Creados</option>
                <option value="api">API</option>
            </select>
            <i></i>
        </div>

    )
}